import { EllipsisOutlined } from '@ant-design/icons'
import { Button, Dropdown } from '@surecompanies/core_components'
import type { MenuProps } from 'antd'
import React from 'react'
import { browserHistory } from 'react-router'
import {
  employeeEnrollmentsPath,
  enrollmentOverlapEmployeePath,
} from '../paths'

interface EmployeeActionsMenuProps {
  runId: string
  employeePublicKey: string
}

/** Row actions: open the overlap detail, or edit the employee's enrollments. */
export default function EmployeeActionsMenu({
  runId,
  employeePublicKey,
}: EmployeeActionsMenuProps) {
  const items: MenuProps['items'] = [
    {
      key: 'details',
      label: 'Details',
      onClick: () =>
        browserHistory.push(
          enrollmentOverlapEmployeePath(runId, employeePublicKey)
        ),
    },
    {
      key: 'edit-enrollment',
      label: 'Edit enrollment',
      // A new tab keeps this report open to compare against while editing.
      onClick: () =>
        window.open(
          employeeEnrollmentsPath(employeePublicKey),
          '_blank',
          'noopener,noreferrer'
        ),
    },
  ]

  return (
    // React events bubble through the dropdown's portal, so stop them here or
    // a menu click would also trigger the table row's own click handler.
    <span role="presentation" onClick={(event) => event.stopPropagation()}>
      <Dropdown menu={{ items }} trigger={['click']}>
        <Button
          type="text"
          aria-label="Actions"
          aria-haspopup="menu"
          icon={<EllipsisOutlined />}
        />
      </Dropdown>
    </span>
  )
}
